import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { GlobalVarsModel } from "@models/ModelGlobalsVar";
import { SportsTitleCasePipe } from "@sports-pipes/index";
import { SportsConstants } from "@sports-utils/index";

@Component({
  selector: "sb-grid-content-thumbnail",
  templateUrl: "./sb-grid-content-thumbnail.html",
  styleUrls: ["./sb-grid-content-thumbnail.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SportsTitleCasePipe, CommonModule, FormsModule],
})
export class SbGridContentThumbnailComponent {
  @ViewChild("imageRef") imageRef: ElementRef;
  @Input() title: string;
  @Input() text: string;
  @Input() startDate: string;
  @Input() sport: string;
  @Input() jockeyColors: string;
  @Input() cloth: string;
  @Input() defaultURL: string;
  @Input() position: number;
  @Input() countryCode: string;
  image: string;
  globalVars!: GlobalVarsModel;

  ngOnChanges() {
    if (this.sport === "greyhound_racing" && !this.image) {
      this.image = this.silkNumber;
      return;
    }
    if (this.startDate && this.jockeyColors && !this.image) {
      this.setRaceImage();
    }
  }

  private setRaceImage() {
    this.image = `${SportsConstants.silksURL}${this.jockeyColors}`;
  }

  private get formatDate(): string {
    const parsedDate = parseFloat(this.startDate.substring(6, 19));
    const date = new Date(parsedDate);
    const [day, month, year] = [date.getDate(), date.getMonth() + 1, date.getFullYear().toString()];

    const formatted = {
      day: day < 10 ? "0" + day : day.toString(),
      month: month < 10 ? "0" + month : month.toString(),
      year: year.substring(2),
    };

    return formatted["day"] + formatted["month"] + formatted["year"];
  }

  defaultErrorImage() {
    const globalVars = new GlobalVarsModel(window.GLOBALS);
    this.image = this.defaultURL
      ? `assets/sports/img/silks/${this.cloth}.png`
      : globalVars.URLBASE + "AppWeb/images/icon/Silks/" + this.cloth + ".png";
    this.imageRef.nativeElement.onError = null;
  }

  get silkNumber(): string {
    if (
      this.cloth &&
      this.sport === "greyhound_racing" &&
      (this.countryCode === "US" || this.countryCode === "AU" || this.countryCode === "GB")
    ) {
      return "assets/sports/img/silks/" + this.countryCode + "/" + this.cloth + ".png";
    }
    return this.cloth ? this.defaultURL + "AppWeb/images/icon/Silks/" + this.cloth + ".png" : "";
  }

  get hasPosition(): boolean {
    return this.sport !== "greyhound_racing";
  }
}
